import { Subscription } from "@/types";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useSubscriptions = (
  projectId: string,
  topicName: string,
  options?: Omit<UseSuspensePaginatedQueryOptions<Subscription>, "queryKey" | "url">,
) => {
  return useSuspensePaginatedQuery<Subscription>({
    queryKey: ["projects", projectId, "topics", topicName, "subscriptions"],
    url: `/projects/${projectId}/topics/${encodeURIComponent(topicName)}/subscriptions`,
    ...options
  });
};
